import type { ReactElement } from 'react';
import type { ChannelDto } from '@gr/core/distribution/channels/dto';
import type { SchemeDto } from '@gr/core/distribution/scheduling/dto';
import { useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { Button } from '../../../../ui-kit/Button/Button';
import { EmptyState } from '../../../../ui-kit/EmptyState/EmptyState';
import { schemeSummary } from '../model/scheme-form';
import styles from './SchemeList.module.scss';

export interface SchemeListProps {
  schemes: readonly SchemeDto[];
  channels: readonly ChannelDto[];
  pending: boolean;
  onEdit(scheme: SchemeDto): void;
  onDelete(scheme: SchemeDto): void;
}

/** SCH-UC-1, SCH-UC-1.CC-1: схемы публикации словами и число постов в очереди по каждой. */
export function SchemeList({ schemes, channels, pending, onEdit, onDelete }: SchemeListProps): ReactElement {
  const { t } = useT();
  if (schemes.length === 0) return <EmptyState title={t('scheduling.schemes.empty')} text={t('scheduling.schemes.emptyText')} />;
  return (
    <ul className={styles.list}>
      {schemes.map((scheme) => (
        <li key={scheme.id} className={styles.item}>
          <div className={styles.info}>
            <strong>{scheme.name}</strong>
            <span className="u-muted u-small">{schemeSummary(scheme, channels, t)}</span>
          </div>
          <div className="u-row">
            {scheme.queueCount > 0 ? <Badge tone="accent">{t('scheduling.schemes.queueCount', { n: scheme.queueCount })}</Badge> : null}
            <Button size="sm" icon="edit" onClick={() => onEdit(scheme)}>
              {t('common.edit')}
            </Button>
            <Button size="sm" variant="ghost" icon="trash" disabled={pending} onClick={() => onDelete(scheme)}>
              {t('common.delete')}
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
